/* eslint-disable no-nested-ternary */
/* eslint-disable max-lines */
/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { SearchBox } from '@bvt-shared/component/SearchBox';
import { getIcon } from '@bvt-shared/utils/iconUtils';
import { cleanFalseKeys } from '../utils/format';
import SelectRadio from '../SelectRadio';
import CheckboxItem from '../Checkbox';
import Nodata from '../NoData';
import './_parameterPoi.scss';
import DynamicIcon from '@bvt-icons';
import { set } from 'lodash';

/**
 * @param {object} props
 * @param {'parset_poi'|'datex_poi'} props.feat
 * @param {object} props.styleHeader
 * @param {boolean} props.withButtonText
 * @param {number} [props.height]
 * @param {object} props.style
 * @param {Array<Object>} props.dataListPoi
 * @param {number} props.widthSearch
 * @param {number} props.widthSelect
 * @param {Array<{label: string, value: string|number, id: string|number}} props.optionIndustry
 * @param {Array<{label: string, value: string|number, id: string|number}} props.optionGroup
 * @param {string | number} props.valueIndustry
 * @param {string | number} props.valueGroup
 * @param {boolean} props.isActiveGroup
 * @param {(value:string) => void} props.onSearch
 * @param {(value:string) => void} props.onChangeIndustry
 * @param {(value:string) => void} props.onChangeGroup
 * @param {Object} props.checkedState
 * @param {(Object) => void} props.setCheckedState
 * @param {(brands: Object[]) => void} props.setBrands
 * @param {(criteria: Object[])} props.setCriterias
 */

export default function ParameterPoi({
  feat,
  dataListPoi,
  checkedState,
  styleHeader,
  widthSearch,
  widthSelect,
  valueIndustry,
  valueGroup,
  optionIndustry,
  optionGroup,
  isActiveGroup,
  style,
  withButtonText = true,
  height = `500px`,
  onSearch,
  onChangeIndustry,
  onChangeGroup,
  setCheckedState,
  setBrands,
  setCriterias,
}) {
  const [containerHeight, setContainerHeight] = useState(0);
  const [containerBoxHeight, setContainerBoxHeight] = useState(0);
  const [expanded, setExpanded] = useState([]);
  const toggleExpand = (id) => {
    setExpanded((prev) =>
      prev.includes(id) ? prev.filter((e) => e !== id) : [...prev, id]
    );
  };
  const getClientHeight = (value) => {
    const docs = document.querySelector(value);
    return docs ? docs.clientHeight : 0;
  };
  const handleContentHeight = () => {
    const content = getClientHeight('.ParameterPOI__wrapper_poi');
    const contentHeader = getClientHeight('.ParameterPOI__body_filter');
    const industryLabel = getClientHeight(
      '.ParameterPOI__body_parameter_table-header'
    );
    const groupContainer = content - contentHeader;
    setContainerHeight(groupContainer);
    setContainerBoxHeight(groupContainer - industryLabel);
  };

  // GET ALL KEYS
  const getAllKeys = (industry) => {
    if (!Array.isArray(industry.group_poi)) {
      return [];
    }
    return industry.group_poi.flatMap((poi) => {
      if (poi?.type?.toLowerCase() === 'brand') {
        return poi.group_brand.map((b) => `brand:${b.brand_name}`);
      }
      if (poi?.type?.toLowerCase() === 'criteria') {
        return poi.group_criteria.map((c) => `criteria:${c.criteria_value}`);
      }
      return [];
    });
  };
  // GET CHILDREN KEYS
  const getChildrenKey = (parentLabel, items) =>
    items.map((item) => `${parentLabel}:${item}`).sort();

  // IS ALL CHECKED
  const isAllChecked = (industry) => {
    const keys = getAllKeys(industry);
    return (
      keys.length > 0 && keys.every((key) => checkedState && checkedState[key])
    );
  };
  // IS SOME CHECKED
  const isSomeChecked = (industry) => {
    const keys = getAllKeys(industry);
    const checkedCount = keys.filter(
      (key) => checkedState && checkedState[key]
    )?.length;
    return keys.length > 0 && checkedCount > 0 && checkedCount < keys.length;
  };
  // HANDLE CHECKED PARENT ALL
  const handleCheckedAll = (industry) => {
    const keys = getAllKeys(industry);
    if (keys.length === 0) {
      return;
    }
    const allChecked = keys.every((key) => checkedState && checkedState[key]);
    const updated = { ...checkedState };
    keys.forEach((key) => {
      updated[key] = !allChecked;
    });
    if (setCheckedState) {
      setCheckedState(cleanFalseKeys(updated));
    }
  };

  // IS GROUP CHECKED CHILDREN
  const isGroupChecked = (groupKey, children) => {
    const keys = getChildrenKey(groupKey, children);
    return (
      keys.length > 0 && keys.every((key) => checkedState && checkedState[key])
    );
  };
  // IS GROUP INDETERMINATE
  const isGroupIndeterminate = (groupKey, children) => {
    const keys = getChildrenKey(groupKey, children);
    const checkedCount = keys.filter(
      (key) => checkedState && checkedState[key]
    ).length;
    return keys.length > 0 && checkedCount > 0 && checkedCount < keys.length;
  };
  // HANDLE CHECKED GROUP CHILD
  const handleCheckedChildGroup = (groupKey, children) => {
    if (!children || children.length === 0) {
      return;
    }
    const allChecked = isGroupChecked(groupKey, children);
    const updated = { ...checkedState };
    getChildrenKey(groupKey, children).forEach((key) => {
      updated[key] = !allChecked;
    });
    if (setCheckedState) {
      setCheckedState(cleanFalseKeys(updated));
    }
  };
  // HANDLE CHECKED CHILD
  const handleCheckedChild = (key) => {
    const updated = {
      ...checkedState,
      [key]: !checkedState[key],
    };
    if (setCheckedState) {
      setCheckedState(cleanFalseKeys(updated));
    }
  };
  // MAPPING DATA BRAND AND CRITERIA
  const getMappedSelectedData = (data_poi) => {
    const result = {
      brands: [],
      criterias: [],
    };
    if (data_poi && Array.isArray(data_poi)) {
      data_poi?.forEach((industy) => {
        const industry_id = industy?.industry_id;
        const group_id = industy?.group_id;
        const category_id = industy?.category_id;
        const category_name = industy.category_name;
        const category_icon = industy?.category_icon;
        const color = industy?.industry_icon_color;
        const status = industy?.industry_status;

        if (Array.isArray(industy?.group_poi) && industy?.group_poi) {
          industy.group_poi.forEach((poi) => {
            if (poi?.type?.toLowerCase() === 'brand') {
              poi?.group_brand.forEach((brand) => {
                const key = `brand:${brand.brand_name}`;
                if (!checkedState || !checkedState[key]) {
                  return;
                }
                if (checkedState[key]) {
                  result.brands.push({
                    industry_id,
                    group_id,
                    category_id,
                    category_name,
                    category_icon,
                    color,
                    status,
                    brand_id: brand.brand_id,
                  });
                }
              });
            }
            if (poi?.type?.toLowerCase() === 'criteria') {
              poi.group_criteria.forEach((criteria) => {
                const key = `criteria:${criteria.criteria_value}`;
                if (!checkedState || !checkedState[key]) {
                  return;
                }
                if (checkedState[key]) {
                  result.criterias.push({
                    industry_id,
                    group_id,
                    category_id,
                    category_name,
                    category_icon,
                    color,
                    status,
                    criteria_id: criteria.criteria_id,
                  });
                }
              });
            }
          });
        }
      });
    }
    return result;
  };

  // POSITION NO DATA
  const posisitionNodata =
    dataListPoi && dataListPoi?.length === 0 ? 'center' : '';

  useEffect(() => {
    handleContentHeight();
    window.addEventListener('resize', handleContentHeight);
    return () => {
      window.removeEventListener('resize', handleContentHeight);
    };
  }, [height]);

  useEffect(() => {
    const mapped = getMappedSelectedData(dataListPoi);
    const brand = mapped?.brands && mapped?.brands?.length ? mapped.brands : [];
    const criteria =
      mapped?.criterias && mapped?.criterias?.length ? mapped.criterias : [];
    if (setBrands === undefined || setCriterias === undefined) {
      return;
    }
    setBrands(brand);
    setCriterias(criteria);
  }, [checkedState, dataListPoi]);
  return (
    <div
      className='ParameterPOI ParameterPOI__wrapper_poi'
      style={{
        ...style,
        height: height,
        display: 'flex',
        flexDirection: 'column',
        gap: feat === 'datex_poi' ? '0.75rem' : '',
      }}
    >
      {/* HEADER SETUP POI PARAMETER */}
      <div
        className='ParameterPOI__body_filter'
        style={{
          ...styleHeader,
        }}
      >
        <div className='ParameterPOI__content_search'>
          <SearchBox
            handler={{ onSearch, onClear: () => onSearch('') }}
            placeholder='Search Brand'
            width={widthSearch ?? 140}
            withButtonText={withButtonText}
          />
        </div>
        <div className='ParameterPOI__content_filter'>
          {feat === 'parset_poi' && <h1 className='text-filter'>Filter By</h1>}
          <div className='select-content' style={{ width: widthSelect ?? 200 }}>
            <SelectRadio
              label={'Select Industry'}
              onChange={(e) => onChangeIndustry(e)}
              options={optionIndustry ?? []}
              value={valueIndustry ?? ''}
            />
          </div>
          <div
            className={`select-content ${
              isActiveGroup && feat === 'parset_poi' ? '' : 'hidden'
            }`}
            style={{ width: widthSelect ?? 200 }}
          >
            <SelectRadio
              label={'Select Group'}
              onChange={(e) => onChangeGroup(e)}
              options={optionGroup ?? []}
              value={valueGroup ?? ''}
            />
          </div>
        </div>
      </div>

      {/* BODY SETUP POI PARAMETER */}
      <div className='ParameterPOI__body_parameter'>
        <div
          className='ParameterPOI__body_parameter_container'
          style={{ height: containerHeight }}
        >
          <div
            className={`ParameterPOI__body_parameter_table-header ${
              feat === 'parset_poi' ? '' : 'hidden'
            }`}
          >
            <div />
            <div>Category</div>
            <div>Group</div>
            <div>Industry</div>
          </div>
          <div
            className='ParameterPOI__body_parameter_table-body'
            style={{
              height: `${containerBoxHeight}px`,
              justifyContent: posisitionNodata,
            }}
          >
            {dataListPoi && dataListPoi?.length > 0 ? (
              <div
                className='ParameterPOI__body_parameter_tree-menu'
                style={{
                  width: '100%',
                  gap: feat === 'datex_poi' ? '0rem' : '',
                }}
              >
                {dataListPoi.map((industry) => {
                  return (
                    <div
                      className='ParameterPOI__body_parameter_tree-menu-container'
                      key={industry.industry_id}
                      style={{
                        borderBottom:
                          feat === 'datex_poi' ? '1px solid #C9D8DC' : '',
                      }}
                    >
                      <button
                        className='ParameterPOI__body_parameter_tree-menu-header'
                        style={{
                          boxShadow: `${
                            expanded.includes(industry.industry_id) &&
                            industry.group_poi.length > 0
                              ? 'none'
                              : feat === 'datex_poi'
                              ? 'none'
                              : 'rgba(149, 157, 165, 0.2) 0px 8px 24px'
                          }`,
                          gridTemplateColumns: `${
                            feat === 'datex_poi' ? '0.3fr 2fr 1fr' : ''
                          }`,
                          padding: feat === 'datex_poi' ? 0 : '',
                        }}
                      >
                        {/* CheckBox */}
                        <CheckboxItem
                          checked={isAllChecked(industry)}
                          disabled={getAllKeys(industry).length === 0}
                          indeterminate={isSomeChecked(industry)}
                          onChange={() => handleCheckedAll(industry)}
                        />
                        {/* Category Header Tree View */}
                        <button
                          className='ParameterPOI__body_parameter_tree-menu-category'
                          onClick={() => toggleExpand(industry.industry_id)}
                        >
                          <div
                            className={`ParameterPOI__body_parameter_tree-menu-category ${
                              expanded.includes(industry.industry_id) &&
                              industry.group_poi.length > 0
                                ? 'icon-collapse'
                                : ''
                            }`}
                          >
                            <DynamicIcon
                              height='0.875rem'
                              icon='arrow'
                              width='0.875rem'
                            />
                          </div>
                          <div className='category-icon'>
                            <img
                              alt={industry.category_name}
                              height={24}
                              src={getIcon('poi', industry.category_icon)}
                              width={24}
                            />
                          </div>
                          <div className='category-label'>
                            {industry.category_name ?? '-'}
                          </div>
                        </button>
                        {/* Group Header Tree View */}
                        <div
                          className='ParameterPOI__body_parameter_tree-menu-group'
                          style={{
                            flexDirection: feat === 'datex_poi' ? 'column' : '',
                            alignItems: feat === 'datex_poi' ? 'end' : '',
                            textAlign: feat === 'datex_poi' ? 'right' : '',
                            gap: feat === 'datex_poi' ? '0' : '',
                          }}
                        >
                          {feat === 'datex_poi' && (
                            <div
                              className='label-industry'
                              style={{
                                fontSize:
                                  feat === 'datex_poi' ? '0.625rem' : '',
                              }}
                            >
                              {industry.industry_name}
                            </div>
                          )}
                          <div
                            className='label-group'
                            style={{
                              fontSize: feat === 'datex_poi' ? '0.75rem' : '',
                            }}
                          >
                            {industry.group_name}
                          </div>
                        </div>
                        {/* Industry Header Tree View */}
                        {feat === 'parset_poi' && (
                          <div className='ParameterPOI__body_parameter_tree-menu-industry'>
                            <div className='label-industry'>
                              {industry.industry_name}
                            </div>
                          </div>
                        )}
                      </button>
                      {/* Collapse Brand and Criteria */}
                      {expanded.includes(industry.industry_id) &&
                        industry.group_poi.length > 0 && (
                          <div
                            className='ParameterPOI__body_parameter_tree-node-wrapper'
                            style={{
                              padding:
                                feat === 'datex_poi'
                                  ? '0 0 0.5rem 3.55rem'
                                  : '',
                            }}
                          >
                            {Array.isArray(industry.group_poi) &&
                              industry.group_poi.length > 0 &&
                              industry.group_poi?.map((poi) => {
                                if (
                                  poi?.type?.toLowerCase() === 'brand' &&
                                  Array.isArray(poi.group_brand) &&
                                  poi.group_brand.length > 0
                                ) {
                                  const children = poi.group_brand.map(
                                    (b) => b.brand_name
                                  );
                                  return (
                                    <div
                                      className='ParameterPOI__body_parameter_tree-node'
                                      key='brand'
                                    >
                                      <div className='content'>
                                        <CheckboxItem
                                          checked={isGroupChecked(
                                            'brand',
                                            children
                                          )}
                                          indeterminate={isGroupIndeterminate(
                                            'brand',
                                            children
                                          )}
                                          label='Brand'
                                          onChange={() =>
                                            handleCheckedChildGroup(
                                              'brand',
                                              children
                                            )
                                          }
                                        />
                                        <div className='ParameterPOI__body_parameter_tree-node__children'>
                                          {poi.group_brand.map((b) => (
                                            <CheckboxItem
                                              checked={
                                                (checkedState &&
                                                  checkedState[
                                                    `brand:${b.brand_name}`
                                                  ]) ||
                                                false
                                              }
                                              key={b.brand_id}
                                              label={b.brand_name}
                                              onChange={() =>
                                                handleCheckedChild(
                                                  `brand:${b.brand_name}`
                                                )
                                              }
                                            />
                                          ))}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                                if (
                                  poi?.type?.toLowerCase() === 'criteria' &&
                                  Array.isArray(poi.group_criteria) &&
                                  poi.group_criteria.length > 0
                                ) {
                                  const children = poi.group_criteria.map(
                                    (c) => c.criteria_value
                                  );
                                  return (
                                    <div
                                      className='ParameterPOI__body_parameter_tree-node'
                                      key='criteria'
                                    >
                                      <div className='content'>
                                        <div className='underline' />
                                        <CheckboxItem
                                          checked={isGroupChecked(
                                            'criteria',
                                            children
                                          )}
                                          indeterminate={isGroupIndeterminate(
                                            'criteria',
                                            children
                                          )}
                                          label='Criteria'
                                          onChange={() =>
                                            handleCheckedChildGroup(
                                              'criteria',
                                              children
                                            )
                                          }
                                        />
                                        <div className='ParameterPOI__body_parameter_tree-node__children'>
                                          {poi.group_criteria.map((c) => (
                                            <CheckboxItem
                                              checked={
                                                (checkedState &&
                                                  checkedState[
                                                    `criteria:${c.criteria_value}`
                                                  ]) ||
                                                false
                                              }
                                              key={c.criteria_id}
                                              label={c.criteria_value}
                                              onChange={() =>
                                                handleCheckedChild(
                                                  `criteria:${c.criteria_value}`
                                                )
                                              }
                                            />
                                          ))}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                                return null;
                              })}
                          </div>
                        )}
                    </div>
                  );
                })}
              </div>
            ) : (
              <Nodata
                subTitleContent={
                  'Try using different keyword to refine your search'
                }
                textContent={`We couldn't find any data matching "underground."`}
                titleContent={'Data Not Found'}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
